<template lang="pug">
  include ../mixins
  +b.counter.position--relative
    +e.wrapper
      +e.button--decrement.BUTTON(
        :disabled="counter == 1"
        @click="decrement"
        aria-label="decrement"
      )
      +e.input-wrapper
        +e.input.INPUT(
          type="number"
          @input="checkLength()"
          v-model.number="inputValue"
          :disabled="isDisabled"
          min="1"
          max="99999"
        ) {{counter}}
      +e.button--increment.BUTTON(
        :disabled="isDisabled || counter >= 99999"
        @click="increment"
        aria-label="increment"
      )
    +b.counter__error.ma--top_xs.BEM-TEXT(
      v-if="isShowErr"
      tag="p"
      color="red"
    ) {{_('Введіть коректне значення')}}
    +b.counter__error.ma--top_xs.BEM-TEXT(
      v-if="isShowLimit"
      tag="p"
      color="red"
    ) {{_('Товар можна замовити тільки в кількості')}} {{ limit }} {{_('шт.')}}
</template>

<script>
export default {
  name: 'ui-counter',
  props: {
    counterValue: {
      required: false,
      default: () => 1,
    },
    isDisabled: Boolean,
    limit: Number,
  },
  data() {
    return {
      counter: this.counterValue,
      inputValue: this.counterValue,
      isShowErr: false,
      isShowLimit: false,
      requestArray: [],
    }
  },
  watch: {
    counterValue(nval) {
      this.inputValue = nval
    },
  },
  methods: {
    increment() {
      if (99999 >= this.counter) {
        ++this.counter
        ++this.inputValue
        this.emitValue(1)
      } else {
        this.counter = 99999
        this.inputValue = 99999
      }
    },
    decrement() {
      if (0 < this.counter) {
        --this.counter
        --this.inputValue
        this.emitValue(-1)
      } else {
        this.counter = 1
        this.inputValue = 1
      }
    },
    checkLength() {
      if ('' === this.inputValue || 0 === this.inputValue) {
        this.isShowErr = true
        this.isShowLimit = false
        this.$emit('is-counter-error', true)
        return
      }
      this.$emit('is-counter-error', false)
      this.isShowErr = false
      if (this.limit) {
        if (this.limit >= this.inputValue) {
          // console.log(111)
          /* check if value in valid limit
          and get diffence between input
          and existed value */
          if (this.limit >= this.inputValue) {
            const inequality = this.inputValue - this.counter
            this.counter = this.inputValue
            this.emitValue(inequality)
            this.isShowLimit = false
            this.$emit('is-counter-error', false)
            // console.log(333)
          }
        } else {
          // console.log(222)
          this.emitValue()
          this.isShowLimit = true
          this.$emit('is-counter-error', true)
          // this.inputValue = 1
          // this.counter = 1
        }
      } else if (99999 >= this.inputValue && 0 !== this.inputValue.length) {
        // console.log(333)
        const inequality = this.inputValue - this.counter
        this.counter = this.inputValue
        this.emitValue(inequality)
      }
    },
    emitValue(value) {
      const timeout = 500
      /* array of values for request to get the last inputed */
      this.requestArray.push(this.inputValue)
      setTimeout(() => {
        if (value) this.$emit('count', value)
        this.$emit('input-value', this.requestArray.slice(-1).pop())
      }, timeout)
    },
  },
}
</script>
